import React from 'react';

function Markup({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <polyline points="7 8 3 12 7 16" />
      <line x1="14.5" y1="5" x2="9.5" y2="19" />
      <polyline points="17 8 21 12 17 16" />
    </svg>
  );
}

export default Markup;
